<template>
  <v-dialog v-model="confirmDialog" max-width="480px" persistent>
    <v-card class="confirm">
      <div class="confirm__icon" aria-hidden="true"><v-icon>mdi-help-circle-outline</v-icon></div>
      <p class="confirm__title">{{ title }}</p>
      <div class="confirm__actions">
        <v-btn text large @click="cancel">Anulare</v-btn>
        <v-btn class="btn-green confirm__ok" large @click="confirm">Da, continuă</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: String,
  },
  data() {
    return {
      confirmDialog: true,
    };
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>

<style scoped>
.confirm {
  padding: 26px 26px 20px;
}
.confirm__icon .v-icon {
  font-size: 40px;
  color: var(--green);
}
.confirm__title {
  margin: 10px 0 22px;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 1.35rem;
  line-height: 1.3;
  color: var(--ink);
}
.confirm__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
